import HomePage from "./components/HomePage";
import "react-material-symbols/rounded";

function App() {
  return (
    <div className="App ">
      <HomePage />
    </div>
  );
}

export default App;
